export enum AppName {
  TRIBE = 'tribe',
  INFLUENTIAL = 'influential',
  LADBIBLE = 'ladbible',
  PINTEREST = 'pinterest',
}

export default AppName
